import { API_URL } from "../constants";
import { sendSignatureReminder } from "../services/signature.service";

/**
 * Opens the Dokobit signing URL for the current user in a new tab.
 */
export function openDokobitSignUrl(companyId: string, fileId: string): void {
  if (!companyId) return;
  window.open(
    `${API_URL}/${companyId}/dokobit/fetch-sign-url/file/${fileId}`,
    "_blank"
  );
}

/**
 * Returns a handler that sends a signature reminder and optionally runs a callback on success
 * or on failure. Use this to avoid duplicating reminder logic across file/order view containers.
 */
export function createHandleRepeatEmail(
  companyId: string,
  onSuccess?: () => void,
  onError?: () => void
): (signatureId: string) => Promise<void> {
  return async (signatureId: string) => {
    if (!companyId) return;
    try {
      await sendSignatureReminder(companyId, signatureId);
      onSuccess?.();
    } catch (e) {
      console.error("Failed to send reminder", e);
      onError?.();
    }
  };
}
